module.exports = __webpack_public_path__ + "img/gdzmh.3e40732b.jpg";